export default "__VITE_ASSET__0243d022__"